// 公共的确认弹窗
import { Toast } from "cube-ui";
import { Dialog } from "cube-ui";
import router from "../router";
// 通用提示窗
function showToast(content, title) {
  Toast.$create({
    txt: content,
    type: title ? title : "txt"
  }).show();
}

// 通用跳转对话框
function ButDialog(title, content, successful) {
  Dialog.$create({
    type: "confirm",
    title: title,
    content: content,
    onConfirm: () => {
      router.push({ name: successful });
    }
  }).show();
  // this.ButDialog("提示", "返回登录页", "login");
}
function ButDialogs(title, content) {
  Dialog.$create({
    type: "confirm",
    title: title,
    content: content
  }).show();
}

// 提交报价单成功提示
function SuccessDialog(flag, companyName, userName, userPhone, userTel) {
  let dialog = Dialog.$create({
    type: "warning",
    title: "联系信息",
    content:
      "企业名称：" +
      companyName +
      "<br>" +
      "联系人名称：" +
      userName +
      "<br>" +
      "手机号：" +
      userPhone +
      "<br>" +
      "座机号：" +
      userTel,
    onConfirm: () => {
      router.push({ name: "contact" });
    }
  });
  if (flag) dialog.show();
  else dialog.hide();
}

// 提交报价单失败提示
function ErrorDialog(content) {
  Dialog.$create({
    type: "warning",
    title: "提示",
    content: content
  }).show();
}

// 提交报价单余额不足提示
function showDialogAlert(content) {
  this.$createDialog({
    type: "alert",
    showClose: true,
    title: "提示",
    content: content,
    onConfirm: () => {
      router.push({ name: "home" });
    },
    onClose: () => {
      router.push({ name: "home" });
    }
  }).show();
}

function showDialogOfferCopy(content) {
  this.$createDialog({
    type: "alert",
    showClose: true,
    title: "提示",
    content: content,
    onConfirm: () => {},
    onClose: () => {}
  }).show();
}

export {
  showToast,
  SuccessDialog,
  ErrorDialog,
  showDialogAlert,
  showDialogOfferCopy,
  ButDialog,
  ButDialogs
};
